import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Image from '../../../objects/image/SecondaryImage';
import LibraryImage from '../../../objects/image/SecondaryLibraryImage';
import Feedback from './SingleAnswerFeedbackReview'; //eslint-disable-line import/no-named-as-default
import OptionAudioControls from "../../audio/OptionAudioController";
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as assetConstants from '../../../../constants/assetConstants';
import * as appConstants from '../../../../constants/appConstants';
import * as keyboardConstants from '../../../../constants/keyboardConstants';

class AudioAnswerOptionReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            option: this.props.option,
            locale: appHelper.getLocalData(this.props.option),
            responseData: this.props.responseData,
            optionAsset: {
                src: ""
            },
            assetData: {}
        };
        this.onObjectSelected = this.onObjectSelected.bind(this);
        this.getDisabledState = this.getDisabledState.bind(this);
        this.getOptionClass = this.getOptionClass.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getAssetType = this.getAssetType.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
    }

    componentDidMount() {
        this.getAssets();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.responseData !== nextProps.responseData) {
            this.setState({responseData: nextProps.responseData});
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.option)
            });
        }
    }

    componentDidUpdate() {

    }

    getAssets() {
        let screenAsset = {};
        let assetData = {};

        if (appHelper.isDefined(this.state.option.image)) {
            screenAsset = this.getAssetType(this.state.option.image);
            assetData = Object.assign({}, this.state.option.image);
        }

        this.setState({
            screenAsset: Object.assign({}, screenAsset),
            assetData: Object.assign({}, assetData)
        });
    }

    getAssetType(asset) {
        /*
         screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.left);
            //console.log(screenCharacter);
            characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.left);
        * */
        let returnAsset = {};
        if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
            returnAsset = appHelper.getIconAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
            returnAsset = appHelper.getImageAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
            returnAsset = appHelper.getLibraryImageAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
            let characterAsset = appHelper.getCharacterAsset(asset);
            returnAsset = appHelper.getCharacterPose(characterAsset, asset);
        }
        returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

        if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
            returnAsset = Object.assign({}, returnAsset, {
                type: asset.constant
            });
        }

        return returnAsset;
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getOptionClass() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
        let activeClass = "";
        if (this.props.optionReviewId === this.state.option.option_id) {
            activeClass = "review-current";
        }
        if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id)) {
            return `review-selected ${this.state.option.result} ${activeClass}`;
        } else {
            return `review ${this.state.option.result} ${activeClass}`;
        }
    }


    getDisabledState() {
        return `disabled`;
    }



    onObjectSelected() {
        this.props.onOptionClick(this.state.option);
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.onObjectSelected();
        }

        if (event.which === keyboardConstants.ARROW_UP_KEY) {
            event.preventDefault();
            let optionIndex = appHelper.getArrayObjectIndexByKey(this.props.options, "option_id", this.state.option.option_id);
            let nextIndex = optionIndex - 1;

            if (optionIndex === 0) {
                nextIndex = this.props.options.length - 1;
            }
            //console.log(nextIndex);
            let nextItem = Object.assign({}, this.props.options[nextIndex]);
            let focusItem = document.getElementById(`review_option_${nextItem.option_id}`);
            focusItem.focus();
        }

        if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
            event.preventDefault();
            let optionIndex = appHelper.getArrayObjectIndexByKey(this.props.options, "option_id", this.state.option.option_id);
            let nextIndex = optionIndex + 1;
            if (optionIndex === (this.props.options.length - 1)) {
                nextIndex = 0;
            }

            let nextItem = Object.assign({}, this.props.options[nextIndex]);
            let focusItem = document.getElementById(`review_option_${nextItem.option_id}`);
            focusItem.focus();
        }
    }

    render() {

        return (
            <div>
                <div className="audio-option-container review">
                    <div className="option-audio-controls">
                        <OptionAudioControls option={this.state.option}/>
                    </div>
                    <div className={`audio-choice-option ${this.state.option.choice_type} ${this.getOptionClass()}`}
                         ref={this.state.option.option_id}
                         id={`review_option_${this.state.option.option_id}`}
                         onClick={this.onObjectSelected}
                         onKeyDown={this.setKeyboardAccessibility}
                         tabIndex={0}
                         role="button"
                         aria-controls={`review_feedback_wrapper_${this.state.option.option_id}`}
                         aria-expanded={this.props.optionReviewId === this.state.option.option_id}>
                        <input id={`${this.props.asset_id}_${this.state.option.option_id}_review`} type="radio"
                               name={`${this.props.asset_id}_${this.state.option.option_id}_review`}
                               tabIndex="-1"
                               aria-hidden="true" aria-disabled="true"
                               value={this.state.option.option_id} onChange={this.onObjectSelected}/>

                        <label htmlFor={`${this.props.asset_id}_${this.state.option.option_id}_review`}>

                            <div className="label-text" dangerouslySetInnerHTML={{__html: this.state.locale.option}}/>
                            <span
                                className="hidden-el">{appHelper.getOptionResultString(this.state.option.result, false)}</span>
                            {
                                appHelper.isDefined(this.state.assetData.constant)
                                    ?
                                    <div className="image-container">
                                        {this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE || this.state.assetData.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE
                                            ?
                                            this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE
                                                ?
                                                <Image screenObject={this.state.assetData}/>
                                                :
                                                <LibraryImage screenObject={this.state.assetData}/>
                                            :
                                            <img src={this.getImagePath(this.state.screenAsset.src)} alt=""/>
                                        }
                                    </div>
                                    :
                                    null
                            }
                        </label>


                    </div>
                </div>
                {this.props.optionReviewId === this.state.option.option_id
                    ?
                    <div role="region" id={`review_feedback_wrapper_${this.state.option.option_id}`}
                         aria-labelledby={`review_option_${this.state.option.option_id}`}>
                        <Feedback option={this.state.option}
                                  options={this.props.options}
                                  asset_id={this.props.asset_id}
                                  responseData={this.state.responseData}/>
                    </div>
                    : null
                }
            </div>

        );

    }
}

AudioAnswerOptionReview.propTypes = {
    option: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
    asset_id: PropTypes.number.isRequired,
    responseData: PropTypes.object.isRequired,
    optionReviewId: PropTypes.number,
    onOptionClick: PropTypes.func,
    contentData: PropTypes.object,
    trackingData: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

AudioAnswerOptionReview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
        trackingData: state.trackingData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AudioAnswerOptionReview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/singleAnswer/AudioAnswerOptionReview.js
 **/